/*
 * Copyright (c) CIRROM 2025.
 */

export const Spacer = () => {
  return <div style={{ margin: "24px" }}></div>;
};
